import React from 'react';
import { motion } from 'framer-motion';
import { careerStages } from '../data/portfolio';
import { Label } from './Label';
export function CareerJourney() {
  return <section id="career" aria-labelledby="career-heading" className="scroll-mt-20 bg-ink px-6 py-24 md:px-10 md:py-32" data-id="element-59" data-mp="le76aa0qu60b">
      <div className="mx-auto w-full max-w-edge" data-id="element-60" data-mp="v6w627mxlvft">
        <div className="grid gap-10 lg:grid-cols-12" data-id="element-61" data-mp="v879g6cgt16e">
          <div className="lg:col-span-4" data-id="element-62" data-mp="7haadu5rpyck">
            <Label data-id="element-63" data-mp="7i3hwxcjwrvr">The Career</Label>
          </div>
          <div className="lg:col-span-8" data-id="element-64" data-mp="2i7cqus4auem">
            <h2 id="career-heading" className="font-display text-3xl font-normal leading-[1.14] text-paper md:text-[3.25rem]" data-id="element-65" data-mp="2jigwvph6469">
              Four decades across technology, investment &amp; the boardroom
            </h2>
            <p className="mt-7 max-w-2xl text-base leading-relaxed text-stone md:text-lg" data-id="element-66" data-mp="1rusozj5ud2u7">
              One continuous progression: building technology, then financing it, then governing
              it.
            </p>
          </div>
        </div>

        <ol className="mt-20 md:mt-24" data-id="element-67" data-mp="j6ipytrmfzcg">
          {careerStages.map((stage, index) => <motion.li key={stage.organisation} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="relative border-t border-white/15 pb-16 pt-10 last:pb-0 md:pl-10" data-id="element-68" data-mp="j8dfkldu8fmv" data-mpi={index}>
              <span className="absolute left-0 top-0 hidden h-2.5 w-2.5 -translate-y-1/2 rounded-full bg-mint md:block" aria-hidden="true" data-id="element-69" data-mp="domox3d1vo2" />
              {index < careerStages.length - 1 && <span className="absolute left-[4px] top-2 hidden h-[calc(100%-0.5rem)] w-px bg-white/15 md:block" aria-hidden="true" data-id="element-70" data-mp="38wmgcyt4xd7x" />}

              <div className="grid gap-8 lg:grid-cols-12 lg:gap-12" data-id="element-71" data-mp="35tg9nmxowu2x">
                <div className="lg:col-span-4" data-id="element-72" data-mp="31smp93jghxes">
                  <p className="text-sm uppercase tracking-[0.22em] text-paper/70" data-id="element-73" data-mp="31ruyq74pupvd">{stage.era}</p>
                  <p className="mt-3 max-w-[16rem] text-[0.95rem] leading-relaxed text-brass" data-id="element-74" data-mp="3fiq4vbntysv9">
                    {stage.lens}
                  </p>
                </div>

                <div className="lg:col-span-8" data-id="element-75" data-mp="2muluicubdrm8">
                  <h3 className="font-display text-3xl font-normal leading-tight text-paper md:text-[2.5rem]" data-id="element-76" data-mp="2mxgey4dbvcfn">
                    {stage.organisation}
                    {stage.meta && <span className="ml-3 align-middle font-sans text-[11px] uppercase tracking-[0.24em] text-mint" data-id="element-77" data-mp="2wuuv02vc9z7f">
                        {stage.meta}
                      </span>}
                  </h3>
                  <p className="mt-3 text-sm uppercase tracking-[0.18em] text-fog" data-id="element-78" data-mp="7481vocqy3ii">{stage.role}</p>
                  <p className="mt-6 max-w-2xl text-base leading-relaxed text-paper/85 md:text-lg" data-id="element-79" data-mp="1p1ukez5n9934">
                    {stage.summary}
                  </p>

                  <ul className="mt-7 grid gap-x-10 gap-y-3 sm:grid-cols-2" data-id="element-80" data-mp="1u2inij75dgdp">
                    {stage.points.map(point => <li key={point} className="border-t border-white/10 pt-3 text-[0.9rem] leading-relaxed text-stone" data-id="element-81" data-mp="1g3izndrgl5il">
                        {point}
                      </li>)}
                  </ul>
                </div>
              </div>
            </motion.li>)}
        </ol>
      </div>
    </section>;
}